// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Input, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { Mutation } from 'react-apollo'
import { removeTypename } from '../../../common/utils'
import { i18n } from '../../index'
import pageCss from './thumbableServicePage.css'
import { upsertThumbsUpTargetMutation } from './thumbableServiceQueries'
import css from './thumbableServiceTable.css'
export default class ThumbsUpTargetTable extends React.PureComponent<any> {
  state = {
    editable: removeTypename(this.props.data),
    upstream: removeTypename(this.props.data),
    editing: !this.props.data.thumbsUpTarget,
  }
  handleShiftPercentageChange = (key, value) => {
    const editableState = this.state.editable
    this.setState({
      editable: {
        ...editableState,
        shiftPercentages: {
          ...editableState.shiftPercentages,
          [key]: parseFloat(value),
        },
      },
    })
  }
  handleTargetChange = (value) => {
    const editableState = this.state.editable
    this.setState({
      editable: { ...editableState, thumbsUpTarget: parseFloat(value) },
    })
  }
  handleSubmit = (mutate) => async () => {
    if (!this.state.editing) {
      return this.setState({
        editing: true,
      })
    }

    const editableState = this.state.editable
    const {
      data: { upsertThumbsUpTarget: updatedData },
    } = await mutate({
      variables: {
        stationId: this.props.stationId,
        data: { ...editableState, date: new Date() },
      },
    })
    return this.setState({
      editing: false,
      editable: removeTypename(updatedData),
      upstream: removeTypename(updatedData),
    })
  }
  handleCancel = () => {
    return this.setState({
      editing: false,
    })
  }

  render() {
    const {
      editable: { shiftPercentages: editableShiftsState, thumbsUpTarget: editableThumbsUpTarget },
      upstream: { shiftPercentages, thumbsUpTarget },
      editing,
    } = this.state
    return (
      <React.Fragment>
        <h2>{i18n.t('admin.annualTargetHeading')}</h2>
        <Paper>
          <div className={css.component}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={css.tableHeading}>{i18n.t('admin.thumbsUpTargets.annualTarget')}</TableCell>
                  <TableCell className={css.tableHeading}>
                    {i18n.t('admin.thumbsUpTargets.morningShiftWeight')} (%)
                  </TableCell>
                  <TableCell className={css.tableHeading}>
                    {i18n.t('admin.thumbsUpTargets.eveningShiftWeight')} (%)
                  </TableCell>
                  <TableCell className={css.tableHeading}>
                    {i18n.t('admin.thumbsUpTargets.nightShiftWeight')} (%)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={css.tableCell}>
                    {editing ? (
                      <Input
                        type='number'
                        value={editableThumbsUpTarget || 0}
                        onChange={(e) => this.handleTargetChange(e.target.value)}
                      />
                    ) : (
                      thumbsUpTarget
                    )}
                  </TableCell>
                  {Object.keys(editableShiftsState).map((key, i) => {
                    return editing ? (
                      <TableCell key={i} className={css.tableCell}>
                        <Input
                          type='number'
                          onChange={(e) => this.handleShiftPercentageChange(key, e.target.value)}
                          value={editableShiftsState[key]}
                        ></Input>
                      </TableCell>
                    ) : (
                      <TableCell key={i} className={css.tableCell}>
                        {shiftPercentages[key]}
                      </TableCell>
                    )
                  })}
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Paper>
        <Mutation mutation={upsertThumbsUpTargetMutation}>
          {(mutate, { loading, error }) => (
            <div className={pageCss.bottom}>
              {editing && (
                <Button
                  style={{
                    marginRight: '10px',
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={this.handleCancel}
                >
                  {i18n.t('buttons.cancel')}
                </Button>
              )}

              <Button
                variant='contained'
                disabled={loading || (editing && !editableThumbsUpTarget)}
                color='primary'
                type='submit'
                onClick={this.handleSubmit(mutate)}
              >
                {loading ? i18n.t('common.load') : editing ? i18n.t('buttons.save') : i18n.t('buttons.edit')}
              </Button>
            </div>
          )}
        </Mutation>
      </React.Fragment>
    )
  }
}
